import { render, staticRenderFns } from "./BaseCouponList.vue?vue&type=template&id=158ba9f8&scoped=true&"
import script from "./BaseCouponList.vue?vue&type=script&lang=js&"
export * from "./BaseCouponList.vue?vue&type=script&lang=js&"
import style0 from "./BaseCouponList.vue?vue&type=style&index=0&id=158ba9f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ba9f8",
  null
  
)

export default component.exports